import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DefaultSensorGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DefaultSensorGroupsQueryPage = { readonly __typename?: 'RootQueryType', readonly defaultSensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> } };

export type GetCurrentUserQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly allSensors: ReadonlyArray<{ readonly __typename?: 'YalperSystemSensor', readonly name: string, readonly platforms: ReadonlyArray<Types.YalperPlatform> }>, readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly name: string, readonly uuid: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly isValid: boolean, readonly lastError?: string | null, readonly provider: Types.OauthProvider }>, readonly sensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> } } | null } | null };


export const DefaultSensorGroupsDocument = gql`
    query DefaultSensorGroups {
  defaultSensorGroups {
    red
    yellow
    gray
  }
}
    `;

/**
 * __useDefaultSensorGroupsQuery__
 *
 * To run a query within a React component, call `useDefaultSensorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultSensorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultSensorGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultSensorGroupsQuery(baseOptions?: Apollo.QueryHookOptions<DefaultSensorGroupsQueryPage, DefaultSensorGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultSensorGroupsQueryPage, DefaultSensorGroupsQueryVariables>(DefaultSensorGroupsDocument, options);
      }
export function useDefaultSensorGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultSensorGroupsQueryPage, DefaultSensorGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultSensorGroupsQueryPage, DefaultSensorGroupsQueryVariables>(DefaultSensorGroupsDocument, options);
        }
export function useDefaultSensorGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultSensorGroupsQueryPage, DefaultSensorGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultSensorGroupsQueryPage, DefaultSensorGroupsQueryVariables>(DefaultSensorGroupsDocument, options);
        }
export type DefaultSensorGroupsQueryHookResult = ReturnType<typeof useDefaultSensorGroupsQuery>;
export type DefaultSensorGroupsLazyQueryHookResult = ReturnType<typeof useDefaultSensorGroupsLazyQuery>;
export type DefaultSensorGroupsSuspenseQueryHookResult = ReturnType<typeof useDefaultSensorGroupsSuspenseQuery>;
export type DefaultSensorGroupsQueryResult = Apollo.QueryResult<DefaultSensorGroupsQueryPage, DefaultSensorGroupsQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser($id: ID!) {
  allSensors {
    name
    platforms
  }
  currentUser {
    company(id: $id) {
      name
      tokens {
        id
        isValid
        lastError
        provider
      }
      uuid
      sensorGroups {
        red
        yellow
        gray
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;